module.exports = __webpack_public_path__ + "img/concernBtn.b0551a11.png";